<template>
  <div class="column">
    <span>points to be issued instantly</span>
    <input
      class="item-name-input"
      data-cy="instant-points-name-input"
      min="0"
      step="1"
      type="number"
      :class="{ error: isBonusValueEmptyOrLessThan1 }"
      :value="instantPointsDraftState"
      @input="$emit('update:instantPointsDraftState', Number($event.target.value))"
    />
  </div>
</template>

<script>
export default {
  props: {
    instantPointsDraftState: Number
  },

  name: "instant-points-form",

  computed: {
    isBonusValueEmptyOrLessThan1(){
      return !this.instantPointsDraftState ||
             this.instantPointsDraftState < 1;
    },
  }
}
</script>
